import Vue from 'vue'
import VueRouter from 'vue-router'
import accauntLogin from '../views/accountLogin.vue'
import accountRegistration from '../views/accountRegistration.vue'
import accountRecovery from '../views/accountRecovery.vue'
import accountSave from '../views/accountSave.vue'
import personalCabinet from '../views/personalCabinet.vue'
import lectureView from '../views/lectureView.vue'
import testView from '../views/testView.vue'
import gradesView from '../views/gradesView.vue'
import SpaceInvaders from '../views/SpaceInvaders.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: accauntLogin
  },
  {
    path: '/account/registration',
    name: 'accountRegistration',
    component: accountRegistration
  },
  {
    path: '/account/recovery',
    name: 'accountRecovery',
    component: accountRecovery
  },
  {
    path: '/account/save/:tokenId',
    name: 'accountSave',
    component: accountSave
  },
  {
    path: '/personalcabinet/:partId',
    name: 'personalCabinet',
    component: personalCabinet
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/personalcabinet',
    name: 'personalCabinet',
    component: personalCabinet
  },
  {
    path: '/lecture/:lectureId',
    name: 'lectureView',
    component: lectureView
  },
  {
    path: '/test/:testId',
    name: 'testView',
    component: testView
  },
  {
    path: '/grades',
    name: 'gradesView',
    component: gradesView
  },
  {
    path: '/space',
    name: 'SpaceInvaders',
    component: SpaceInvaders
  },
  { 
    path: '/404', 
    component: NotFound 
  },
  { 
    path: '*', 
    redirect: '/404' 
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
